import { render, staticRenderFns } from "./instLoaderGetDemandState.vue?vue&type=template&id=2d8b8ea0&scoped=true"
import script from "./instLoaderGetDemandState.vue?vue&type=script&lang=js"
export * from "./instLoaderGetDemandState.vue?vue&type=script&lang=js"
import style0 from "./instLoaderGetDemandState.vue?vue&type=style&index=0&id=2d8b8ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b8ea0",
  null
  
)

export default component.exports